import { singleConfiguratorAjaxRequest, oldConfiguratorAjaxRequest } from './rotoclear-ajax.js';

const updateQuestionImage = function (questionId, answerElement) {
  const questionElement = document.querySelector(`.content-rotoclear-question[data-question-id="${questionId}"]`);
  const imageElement = questionElement.querySelector('.content-rotoclear-question__image');
  if (!imageElement) {
    return;
  }
  if (!answerElement.dataset.imageBase64) {
    imageElement.src = '';
    return;
  }
  const imageBase64 = atob(answerElement.dataset.imageBase64);
  if (imageBase64) {
    if (imageElement) {
      imageElement.src = imageBase64;
    }
  }
};

const scrollToNextPoint = function (element) {
  element.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
};

document.addEventListener('DOMContentLoaded', function () {
  let interactive_elements = {};
  const configurator = document.querySelector('.module-rotoclear-single-configurator');
  const configuratorQuestionContainer = configurator.querySelector('.rotoclear-configurator__questions');
  const configuratorId = configurator.dataset.configuratorId;
  const requestToken = configurator.dataset.token;
  const requestTokenName = configurator.dataset.tokenName;
  window.language = configurator.dataset.language;
  window.moduleId = configurator.dataset.moduleId;
  const createState = function () {
    const value = {
      answers: {},
      subAnswers: {},
      questions: [],
      accessory: [],
      products: [],
      history: []
    }
    window.accessory_confirmed = false;
    localStorage.setItem("configurator" + configuratorId, JSON.stringify(value));
  }

  const updateState = function (key, value) {
    let state = JSON.parse(localStorage.getItem("configurator" + configuratorId));
    state[key] = value;
    console.log('Update state', key, value);
    localStorage.setItem("configurator" + configuratorId, JSON.stringify(state));
  }

  const getState = function (key) {
    let state = JSON.parse(localStorage.getItem("configurator" + configuratorId));
    return state[key];
  };

  const flattenDeep = function (arr) {
    return arr.reduce((acc, val) => Array.isArray(val) ? acc.concat(flattenDeep(val)) : acc.concat(val), []);
  };
  const addEntryAtPosition = function (array, position, entry) {
    // Ensure the array has enough length to accommodate the position
    if (position >= array.length) {
      array.length = parseInt(position) + 1; // This will fill the array with undefined values up to the position
    }
    // Add the entry at the specified position
    array.splice(position, 1, entry);
  };

  const updateAnswerFromDefault = function (question, answer) {
    // check if answer is an array
    if (Array.isArray(answer)) {
      // If it is an array, we need to update the answer for each entry in the array
      answer.forEach(function (entry, index) {
        updateAnswer(question, entry, index);
      });
    }
    else {
      // If it is not an array, we can just update the answer
      updateAnswer(question, answer.toString());
    }
  }

  const updateAnswer = function (question, answer, position = -1) {
    let state = JSON.parse(localStorage.getItem("configurator" + configuratorId));
    if (position > -1) {
      if (!Array.isArray(state.answers[question])) {
        state.answers[question] = [];
      }
      addEntryAtPosition(state.answers[question], position, answer);
    } else {
      state.answers[question] = answer;
    }
    // Remove undefined values from the array
    if (Array.isArray(state.answers[question])) {
      state.answers[question] = state.answers[question].filter(item => item !== undefined && item !== "");
    }
    localStorage.setItem("configurator" + configuratorId, JSON.stringify(state));
  }

  const updateSubAnswer = function (answer, parentAnswer, position = -1) {
    let state = JSON.parse(localStorage.getItem("configurator" + configuratorId));
    if (position > -1) {
      if (!Array.isArray(state.subAnswers[parentAnswer])) {
        state.subAnswers[parentAnswer] = [];
      }
      addEntryAtPosition(state.subAnswers[parentAnswer], position, answer);
    } else {
      state.subAnswers[parentAnswer] = answer;
    }
    // Remove undefined values from the array
    if (Array.isArray(state.subAnswers[parentAnswer])) {
      state.subAnswers[parentAnswer] = state.subAnswers[parentAnswer].filter(item => item !== undefined && item !== "");
    }
    localStorage.setItem("configurator" + configuratorId, JSON.stringify(state));
  }

  const loadProduct = function (productId) {
    singleConfiguratorAjaxRequest(`product/${productId}`, 'GET', {}, function (result) {
      const json = JSON.parse(result.response);
      console.log(json);
      insertProduct(productId, json.data)
    })
  }

  const loadQuestion = function (questionId) {
    if (questionId === undefined || questionId === null || questionId === -1) {
      return;
    }
    singleConfiguratorAjaxRequest(`question/${questionId}`, 'GET', {}, function (result) {
      const json = JSON.parse(result.response);
      const questionElement = insertQuestion(questionId, json.questionGroup, json.data);
      if (!questionElement) {
        console.error("Couldn't find question", questionId + " after inserting it");
      }
      // Check if we have saved a answer for this question
      const savedAnswer = getState('answers')[questionId];
      if (savedAnswer) {
        questionElement.dataset.selectedAnswer = savedAnswer;
      } else {
        updateAnswerFromDefault(questionId, JSON.parse(questionElement.dataset.selectedAnswer));
      }
      updateAnswerClasses();
      // Add event listener
      questionElement.querySelectorAll('.content-rotoclear-answer .content-rotoclear-answer__checkbox input').forEach(function (button) {
        button.addEventListener('click', handleChooseClick);
      });
      // Add select Event listener for questions
      questionElement.querySelectorAll('select').forEach(function (select) {
        select.addEventListener('change', handleSelectChange);
      });
    }, function (error) {
      console.log(error);
    });
  }

  const insertProduct = function (id, content) {
    const accessoryContainer = configurator.querySelector('.rotoclear-configurator__accessory')
    // Check if we already have this accessory 
    let productElement = configurator.querySelector(`[data-product-id="${id}"]`);
    if (!productElement) {
      accessoryContainer.insertAdjacentHTML('beforeend', content);
    }
    productElement = configurator.querySelector(`[data-product-id="${id}"]`);
    productElement.querySelector('input[type="checkbox"]').addEventListener('change', handleProductChange);
    if (configurator) {
      const event = new CustomEvent('productAdded', { detail: { productId: id } });
      configurator.dispatchEvent(event);
    }
  }
  /**
   * Inserts a question into the configurator.
   * @param {*} id - The ID of the question.
   * @param {*} group - The group the question belongs to.
   * @param {*} content - The HTML content of the question.
   * @returns {HTMLElement|null} Reference to inserted question
   */
  const insertQuestion = function (id, group, content) {
    // Check if there is a question already dependendt on group or no group
    const selector = group ? `.rotoclear-configurator__question-group__question[data-question-id="${id}"]` : `.content-rotoclear-question[data-question-id="${id}"]`;
    let question = configurator.querySelector(selector);
    if (question) {
      console.error("Question already exists", id, group);
      return question;
    }
    // Search for the group if there is one
    if (group) {
      question = insertQuestionInGroup(id, group, content);
    } else {
      question = insertGrouplessQuestion(id, content);
    }
    if (configuratorQuestionContainer) {
      const event = new CustomEvent('questionAdded', { detail: { questionId: id, groupId: group || null } });
      configurator.dispatchEvent(event);
    }
    return question;
  }
  const insertGrouplessQuestion = function (id, content) {
    let questionsContainer = configurator.querySelector('.rotoclear-configurator__questions');
    questionsContainer.insertAdjacentHTML('beforeend', content);
    // Find the inserted question
    const question = configurator.querySelector(`.content-rotoclear-question[data-question-id="${id}"]`);
    if (!question) {
      console.error("Couldn't find question", id + " after inserting it outside of a group");
      return null;
    }
    return question;
  }

  const insertQuestionInGroup = function (id, group, content) {
    let groupElement = configurator.querySelector(`.content-rotoclear-question-group[data-question-group-id="${group}"]`);
    if (!groupElement && group) {
      // TODO: Create the group
      console.error("Couldn't find group", group);
    }
    // Find the last question in the group
    const lastQuestion = groupElement.querySelector('.rotoclear-configurator__question-group__question[data-question-group-id="' + group + '"]:last-of-type');
    if (lastQuestion) {
      lastQuestion.insertAdjacentHTML('afterend', content);
    } else {
      groupElement.insertAdjacentHTML('afterend', content);
    }
    // Find the inserted question
    const question = configurator.querySelector(`.content-rotoclear-question[data-question-id="${id}"]`);
    return question;
  }

  const removeOldQuestion = function (questionId) {
    configurator.querySelectorAll(`.content-rotoclear-question[data-question-id="${questionId}"],.rotoclear-configurator__question-group__question[data-question-id="${questionId}"]`).forEach(function (question) {
      question.remove();
    });
  }

  const updateAccessory = function (newAccessory) {
    Object.entries(newAccessory).forEach(function ([key, accessoryId]) {
      const accessoryElement = configurator.querySelector(`.content-rotoclear-accessory[data-accessory-id="${accessoryId}"]`)
      if (!accessoryElement) {
        // Add the new product
        loadProduct(accessoryId);
      }
    });
  };


  const updateQuestions = function (newFollowUpQuestions) {
    let currentQuestions = getState('questions');
    console.log('New Follow Up Questions', newFollowUpQuestions);
    Object.entries(newFollowUpQuestions).forEach(function ([key, questionId]) {
      console.log('Check if questionID is existing',
        questionId,
        currentQuestions.indexOf(questionId.toString()),
        configurator.querySelectorAll(`.content-rotoclear-question[data-question-id="${questionId}"]`));
      if (currentQuestions.indexOf(questionId.toString()) === -1) {
        // Add the new question
        loadQuestion(questionId);
        // Find index of key in currentQuestions
        const index = currentQuestions.indexOf(key.toString());
        console.log('Index of key', key, 'is', index);
        currentQuestions.splice(index, 0, questionId.toString());

        console.log('Current Questions after insert', currentQuestions);
      }
    });
    // indexes to remove
    const toBeRemovedIds = [];
    currentQuestions.forEach(function (questionId) {
      // console.log("Checking question", questionId, newFollowUpQuestions[parseInt(questionId)]);
      if (newFollowUpQuestions[parseInt(questionId)] === undefined) {
        // Remove the question
        removeOldQuestion(questionId);
        // Remove the question from the list
        const index = currentQuestions.indexOf(questionId);
        if (index > -1) {
          toBeRemovedIds.push(questionId);
        }
      }
    });
    console.log("Current Questions before delete", currentQuestions, toBeRemovedIds);
    currentQuestions = currentQuestions.filter(function (questionId) {
      return toBeRemovedIds.indexOf(questionId) === -1;
    });
    console.log('Current questions', currentQuestions);
    updateState('questions', currentQuestions);
  }


  const getAnswerQuestionObject = function () {
    const currentAnswers = getState('answers');
    const currentQuestions = getState('questions');
    return currentQuestions.map(function (question) {
      return {
        question: question,
        answer: currentAnswers[question]
      }
    });
  }
  const getOnlyActiveAnswersArray = function () {
    const currentAnswers = getState('answers');
    const currentQuestions = getState('questions');
    const activeAnswers = currentQuestions.map(function (question) {
      return currentAnswers[question]
    });
    // Add subanswers for selected answers
    const activeSubAnswers = activeAnswers.map(function (answer) {
      if (Array.isArray(answer)) {
        return answer.map(function (answerId) {
          return getSubAnswerForAnswer(answerId);
        })
      } else {
        // If not an array, just return the answer
        return getSubAnswerForAnswer(answer);
      }
    });
    // Concat  activeAnswers and activeSubAnswers
    const onlyActiveAnswers = activeAnswers;
    onlyActiveAnswers.push(...activeSubAnswers);
    const flattened = flattenDeep(onlyActiveAnswers);
    const filtered = flattened.filter(Boolean);
    return filtered;
  }
  const getSubAnswerForAnswer = function (answerId) {
    const subAnswers = getState('subAnswers');
    if (subAnswers[answerId]) {
      return subAnswers[answerId];
    }
    return [];
  }

  const getAccessories = function () {
    const accessory = getState('accessory');
    return accessory;
  }

  const getDatasetOfQuestion = function (questionId) {
    const question = configurator.querySelector(`.content-rotoclear-question[data-question-id="${questionId}"]`);
    return question.dataset;
  }
  const handleChooseClick = function (event) {
    const target = event.currentTarget;
    const answerDataset = target.dataset;
    // Check if we have clicked on a subanswer
    if (answerDataset.parentAnswer > 0) {
      event.stopPropagation();
      handleSubAnswerClick(event, answerDataset);
      updateAnswerClasses();
      return;
    }
    // Check if multiple answers are allowed
    const questionDataset = getDatasetOfQuestion(answerDataset.questionId);
    const allowedAnswersCount = parseInt(questionDataset.allowedAnswersCount);
    if (allowedAnswersCount > 1) {
      // Check if we are disabled, do nothing if
      if (target.classList.contains('disabled')) {
        return;
      }
      // Check if the answer is already selected
      const currentAnswers = getState('answers');
      const currentAnswer = currentAnswers[answerDataset.questionId][answerDataset.answerGroup] || '';
      console.log('Current Answer', currentAnswer, 'Selected Answer', answerDataset.answerId);
      if (currentAnswer === answerDataset.answerId) {
        // Remove the answer
        updateAnswer(answerDataset.questionId, '', answerDataset.answerGroup);
      } else {
        updateAnswer(answerDataset.questionId, answerDataset.answerId, answerDataset.answerGroup);
      }
    } else {
      updateAnswer(answerDataset.questionId, answerDataset.answerId);
    }
    fetchQuestions();
    fetchAccessory();
    updateQuestionImage(answerDataset.questionId, target);
    updateAnswerClasses();
  };
  const handleSelectChange = function (event) {
    const target = event.currentTarget;
    const questionDataset = target.dataset;
    const value = target.value;
    updateAnswer(questionDataset.questionId, value);
    fetchQuestions();
    fetchAccessory();
    updateQuestionImage(questionDataset.questionId, target);
    updateAnswerClasses();
  };

  function handleSubAnswerClick(event, answerDataset) {
    const questionId = answerDataset.questionId;
    const answerId = answerDataset.answerId;
    const answerGroup = answerDataset.answerGroup;
    const parentAnswer = answerDataset.parentAnswer;
    const currentSubAnswers = getState('subAnswers');
    // Check if we have a subanswer for this answerId
    if (!currentSubAnswers[parentAnswer]) {
      currentSubAnswers[parentAnswer] = [];
    }
    // Check if the answer is already selected
    const selectedSubAnswers = currentSubAnswers[parentAnswer];
    const selectedIndex = selectedSubAnswers.indexOf(answerId);
    console.log('Selected Sub Answers', selectedSubAnswers, 'Selected Index', selectedIndex);
    if (selectedIndex > -1) {
      updateSubAnswer(null, parentAnswer, answerGroup);
    } else {
      updateSubAnswer(answerId, parentAnswer, answerGroup);
    }
  }

  const updateProductClass = function (productId, selected = false) {
    const productElement = configurator.querySelector(`.content-rotoclear-product[data-article-number="${productId}"]`);
    if (productElement) {
      productElement.classList.toggle('selected', selected);
    }
  };

  const updateAnswerClass = function (answerElement, selected = false, disabled = false) {
    // find answer Checkbox
    const answerCheckbox = answerElement.querySelector('.content-rotoclear-answer__checkbox input');
    if (answerCheckbox) {
      answerCheckbox.checked = selected;
      answerCheckbox.disabled = disabled;
    }
    if (selected) {
      answerElement.classList.add('selected');
    } else {
      answerElement.classList.remove('selected');
    }
    if (disabled) {
      answerElement.classList.add('disabled');
    } else {
      answerElement.classList.remove('disabled');
    }
  }

  const updateAnswerClasses = function () {
    const currentAnswers = getState('answers');
    const currentSubAnswers = getState('subAnswers');
    const currentQuestions = getState('questions');
    currentQuestions.forEach(function (questionId) {
      const question = configurator.querySelector(`.content-rotoclear-question[data-question-id="${questionId}"]`);
      if (!question) {
        console.warn("Couldn't find question", questionId);
        return;
      }
      // Read out answer from state
      const selectedAnswer = currentAnswers[questionId];
      if (!selectedAnswer) {
        console.warn("No selected answer for question", questionId);
      }
      question.dataset.selectedAnswerCount = selectedAnswer ? (Array.isArray(selectedAnswer) ? selectedAnswer.reduce((acc, curr) => acc + (curr && curr !== "" ? 1 : 0), 0) : 1) : 0;
      // Got throug all answers of this question
      question.querySelectorAll('.content-rotoclear-answer').forEach(function (answerElement) {
        const answerId = answerElement.dataset.answerId;
        let selected = false;
        let disabled = false;
        // Check if we have a subanswer 
        if (answerElement.dataset.parentAnswer > 0) {
          // Check if the parent answer is selected
          const parentAnswer = answerElement.dataset.parentAnswer;
          let parentSelected = false;
          if (Array.isArray(selectedAnswer)) {
            const selectedAnswerIndex = selectedAnswer.indexOf(parentAnswer);
            if (selectedAnswerIndex > -1) {
              parentSelected = true;
            }
          } else {
            parentSelected = selectedAnswer === parentAnswer;
          }
          disabled = !parentSelected;
          if (parentSelected && currentSubAnswers[parentAnswer] && currentSubAnswers[parentAnswer].indexOf(answerId) > -1) {
            selected = true;
          } else {
            selected = false;
          }
        } else {
          // Check if selected answer is an array
          if (Array.isArray(selectedAnswer)) {
            // Check if the answer is in the array
            const selectedAnswerIndex = selectedAnswer.indexOf(answerId);
            // Check if answer is in the right group
            const answerGroup = parseInt(answerElement.dataset.answerGroup);
            selected = selectedAnswerIndex > -1 && selectedAnswerIndex === answerGroup;
            disabled = selectedAnswerIndex > -1 && selectedAnswerIndex !== answerGroup;
          } else {
            selected = selectedAnswer === answerId;
          }
        }
        updateAnswerClass(answerElement, selected, disabled);
        if (selected) {
          updateQuestionImage(questionId, answerElement);
        }
      });
    });
  }

  const updateAnswers = function () {
    const currentAnswers = getState('answers');
    const currentQuestions = getState('questions');
    currentQuestions.forEach(function (questionId) {
      const question = configurator.querySelector(`.content-rotoclear-question[data-question-id="${questionId}"]`);
      let selectedAnswer = JSON.parse(question.dataset.selectedAnswer);
      if (!Array.isArray(selectedAnswer)) {
        selectedAnswer = selectedAnswer.toString();
      }
      console.log('Update answer for question', questionId, 'with selected answer', selectedAnswer);
      currentAnswers[questionId] = selectedAnswer;
    });
    updateState('answers', currentAnswers);
  }

  const handleProductChange = function (event) {
    const target = event.target;
    const dataset = target.dataset;
    const productId = dataset.articleNumber;
    const accessory = getState('accessory');
    if (accessory.indexOf(productId) === -1) {
      accessory.push(productId);
    } else {
      accessory.splice(accessory.indexOf(productId), 1);
    }
    updateProductClass(productId, target.checked);
    updateState('accessory', accessory);
  }

  const handleSubmitContactClick = function (event) {
    event.preventDefault();
    // Disable Submit Button while request is loading
    interactive_elements.contact_confirm.forEach(function (form) {
      form.submit.disabled = true;
      form.submit.dataset.loading = true;
    });
    const dataset = event.target.dataset;
    const request_token = requestToken;
    const requesttokenname = requestTokenName;
    const contactFormData = new FormData(event.target);
    console.log(contactFormData);
    let contactForm = {};
    for (var key of contactFormData.keys()) {
      console.log(key, contactFormData.getAll(key));
      const values = contactFormData.getAll(key);
      // Find the first non-empty entry
      const firstNonEmpty = values.find(v => v !== null && v !== undefined && v !== '');
      contactForm[key] = firstNonEmpty !== undefined ? firstNonEmpty : '';
    }

    const data = { contact: contactForm, answers: getOnlyActiveAnswersArray(), accessory: getAccessories() };
    const requestTimeout = setTimeout(() => {
      alert("Request timed out");
      interactive_elements.contact_confirm.forEach(function (form) {
        form.submit.disabled = false;
        form.submit.dataset.loading = false;
      });
    }, 30000);
    oldConfiguratorAjaxRequest('send_offer', 'POST', { [requesttokenname]: request_token }, function (result) {
      const json = JSON.parse(result.response);
      console.log(json);
      clearTimeout(requestTimeout);
      // updateEventListeners();
      // Check for validation errors
      if (json.status > 200) {
        switch (json.status) {
          case 201: // We have some validation errors
            if (json.data) {
              for (const field in json.data) {
                if (Object.hasOwnProperty.call(json.data, field)) {
                  const hasError = json.data[field];
                  const formField = configurator.querySelector(`#ctrl_${field}`);
                  formField.validity.valueMissing = true;
                  formField.required = true;
                  formField.reportValidity();
                  console.log('field', field, 'hasError', hasError);
                }
              }
            }
            break;

          default:
            break;
        }
        interactive_elements.contact_confirm.forEach(function (form) {
          form.submit.disabled = false;
          form.submit.dataset.loading = false;
        });
        return -1;
      }
      configurator.innerHTML = "";
      const article = document.createElement('div');
      article.classList.add('mod_article');
      const inside = document.createElement('div');
      inside.classList.add('inside');
      inside.insertAdjacentHTML('beforeend', json.data.template_message);
      article.insertAdjacentElement('beforeend', inside);
      configurator.insertAdjacentElement('beforeend', article);
      scrollToNextPoint(article);
      interactive_elements.contact_confirm.forEach(function (form) {
        form.submit.disabled = false;
        form.submit.dataset.loading = false;
      });
    }, function (result) {
      console.warn("Something went wrong, please contact support", result);
      interactive_elements.contact_confirm.forEach(function (form) {
        form.submit.disabled = false;
        form.submit.dataset.loading = false;
      });
    }, data)

  }

  const fetchQuestions = function () {
    const activeAnswers = getAnswerQuestionObject();
    const allAnswers = getState('answers');
    const data = {
      activeAnswers,
      allAnswers
    }
    singleConfiguratorAjaxRequest(`questionsforanswers/${configuratorId}`,
      'POST',
      { REQUEST_TOKEN: requestToken },
      function (result) { console.log(result); const json = JSON.parse(result.response); updateQuestions(json); },
      function (xhr) { },
      data);
  }

  const fetchAccessory = function () {
    singleConfiguratorAjaxRequest(`accessory/${configuratorId}`,
      'POST',
      { REQUEST_TOKEN: requestToken },
      function (result) { const json = JSON.parse(result.response); console.log(json); updateAccessory(json.accessories); },
      function (xhr) { },
      { answers: getOnlyActiveAnswersArray(), REQUEST_TOKEN: requestToken });
  }
  const registerEventListeners = function () {
    // Add all Button event listeners
    configurator.querySelectorAll('.content-rotoclear-answer .content-rotoclear-answer__checkbox input').forEach(function (button) {
      button.addEventListener('click', handleChooseClick);
    });
    // Add select Event listener for questions
    configurator.querySelectorAll('.content-rotoclear-question select').forEach(function (select) {
      select.addEventListener('change', handleSelectChange);
    });
    // Add submit button event listener
    interactive_elements.contact_confirm = configurator.querySelectorAll('.content-rotoclear-contact form')
    interactive_elements.contact_confirm.forEach((e) => {
      e.addEventListener('submit', handleSubmitContactClick);
    });
    // Remove excessive checkbox hidden inputs
    configurator.querySelectorAll('.content-rotoclear-contact form .tl_checkbox_single_container input[type="hidden"]').forEach(function (checkbox) {
      checkbox.remove();
    });
  }
  createState();
  // Read out selected answers
  const selectedAnswers = {};
  const currentQuestions = [];
  configurator.querySelectorAll('.content-rotoclear-question').forEach(function (question) {
    currentQuestions.push(question.dataset.questionId);
    selectedAnswers[question.dataset.questionId] = question.dataset.selectedAnswer;
  });
  updateState('questions', currentQuestions);
  updateState('answers', selectedAnswers);

  registerEventListeners();
  fetchAccessory();
  updateAnswers();
  updateAnswerClasses();
  if (configurator) {
    const event = new CustomEvent('configuratorInitialized', { detail: { configurator } });
    configurator.dispatchEvent(event);
  }
});